// src/pages/Appli/AppliAdmin/DashboardAdmin.jsx
import React from "react";
import useScrollToTop from "../../../hooks/useScollToTop";
import VisitesPanel from "./VisitesPanel";
import RolesDistributionPanel from "./RolesDistributionPanel";
import ContactMessagesPanel from "./ContactMessagesPanel";

import AdminDashboardStatsCards from "./AdminDashboardStatsCards";
import AdminDashboardFutureWidgets from "./AdminDashboardFutureWidgets";

import {
  FaChartLine,
  FaUsers,
  FaEnvelopeOpenText,
} from "react-icons/fa";

function CompactStat({ icon, label, value, accent = "indigo" }) {
  const accents = {
    indigo:
      "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300",
    emerald:
      "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
    amber:
      "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",
  };

  return (
    <div className={`rounded-2xl border px-3 py-3 ${accents[accent]}`}>
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white/80 dark:bg-slate-900/50">
          {icon}
        </div>
        <div className="min-w-0">
          <div className="text-[11px] uppercase tracking-[0.16em] opacity-75">
            {label}
          </div>
          <div className="mt-0.5 text-xl font-bold text-slate-900 dark:text-white">
            {value}
          </div>
        </div>
      </div>
    </div>
  );
}

function AdminPageHeader() {
  return (
    <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
          <div className="min-w-0">
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Administration
            </p>
            <h1 className="mt-1 text-2xl font-bold text-slate-900 sm:text-[30px] dark:text-white">
              Dashboard
            </h1>
            <p className="mt-2 max-w-3xl text-sm text-slate-600 dark:text-slate-300">
              Vue d’ensemble des usages et des principaux indicateurs de
              l’application.
            </p>
          </div>

          {/* <div className="grid gap-3 sm:grid-cols-3 xl:min-w-[620px]">
            <CompactStat
              icon={<FaChartLine />}
              label="Pilotage"
              value="Admin"
              accent="indigo"
            />
            <CompactStat
              icon={<FaUsers />}
              label="Vue"
              value="Globale"
              accent="emerald"
            />
            <CompactStat
              icon={<FaEnvelopeOpenText />}
              label="Suivi"
              value="Temps réel"
              accent="amber"
            />
          </div> */}
        </div>
      </div>
    </div>
  );
}

const DashboardAdmin = () => {
  useScrollToTop();

  return (
    <div className="w-full pb-10 pt-[96px] font-satoshi">
      <div className="mx-auto max-w-[1400px] px-4">
        <AdminPageHeader />

        <div className="mt-5">
          <AdminDashboardStatsCards />
        </div>

        <div className="mt-5 gap-5 ">
          <div className="xl:col-span-7 mb-4">
            <VisitesPanel />
          </div>

          <div className="xl:col-span-5 mb-4">
            <RolesDistributionPanel />
          </div>

          <div className="xl:col-span-12">
            <ContactMessagesPanel />
          </div>
        </div>

        {/* <div className="mt-6">
          <AdminDashboardFutureWidgets />
        </div> */}
      </div>
    </div>
  );
};

export default DashboardAdmin;